import {
  $HttpClientOptions,
  CountriesResource,
  DisputesResource,
  OrderRevenueRegionChartsResource,
  OrderRevenueTimelineChartsResource,
  OrganizationAccountsResource,
  OrganizationBillingStatementsResource,
  ItemHarmonizationsResource,
  FeatureValuesResource,
  FraudReviewDecisionsResource,
  QueryBuildersResource,
  FeaturesResource,
  CenterQueryBuildersResource,
  ClassificationStatisticsResource,
  MembershipsResource,
  OrderAddressValidationsResource,
  UsersResource,
  InternalDebugTransactionsResource,
  LabelRequestResultsResource,
  UserOneTimeTokensResource,
  ItemClassificationSummariesResource,
  OrderDetailsResource,
  OrderSettingsResource,
} from '@flowio/api-internal-sdk';
// checkoutConfigurations was dropped from the current api-internal SDK but its
// endpoint is still live and no current SDK (internal or public) exposes it yet.
// Pin it to the legacy SDK until it's migrated (tracked in COR-4382).
import { CheckoutConfigurationsResource as LegacyCheckoutConfigurationsResource } from '@flowio/api-internal-sdk-legacy';

export class ApiInternalClientV2 {
  countries: CountriesResource;

  disputes: DisputesResource;

  orderRevenueRegionCharts: OrderRevenueRegionChartsResource;

  orderRevenueTimelineCharts: OrderRevenueTimelineChartsResource;

  organizationAccounts: OrganizationAccountsResource;

  organizationBillingStatements: OrganizationBillingStatementsResource;

  itemHarmonizations: ItemHarmonizationsResource;

  itemClassificationSummaries: ItemClassificationSummariesResource;

  debugTransactions: InternalDebugTransactionsResource;

  labelRequestResults: LabelRequestResultsResource;

  featureValues: FeatureValuesResource;

  fraudReviewDecisions: FraudReviewDecisionsResource;

  queryBuilders: QueryBuildersResource;

  features: FeaturesResource;

  centerQueryBuilders: CenterQueryBuildersResource;

  classificationStatistics: ClassificationStatisticsResource;

  memberships: MembershipsResource;

  orderAddressValidations: OrderAddressValidationsResource;

  users: UsersResource;

  userOneTimeTokens: UserOneTimeTokensResource;

  orderDetails: OrderDetailsResource;

  orderSettings: OrderSettingsResource;

  checkoutConfigurations: LegacyCheckoutConfigurationsResource;

  constructor(options: $HttpClientOptions) {
    this.countries = new CountriesResource(options);
    this.disputes = new DisputesResource(options);
    this.orderRevenueRegionCharts = new OrderRevenueRegionChartsResource(options);
    this.orderRevenueTimelineCharts = new OrderRevenueTimelineChartsResource(options);
    this.organizationAccounts = new OrganizationAccountsResource(options);
    this.organizationBillingStatements = new OrganizationBillingStatementsResource(options);
    this.itemHarmonizations = new ItemHarmonizationsResource(options);
    this.itemClassificationSummaries = new ItemClassificationSummariesResource(options);
    this.featureValues = new FeatureValuesResource(options);
    this.fraudReviewDecisions = new FraudReviewDecisionsResource(options);
    this.queryBuilders = new QueryBuildersResource(options);
    this.features = new FeaturesResource(options);
    this.centerQueryBuilders = new CenterQueryBuildersResource(options);
    this.classificationStatistics = new ClassificationStatisticsResource(options);
    this.memberships = new MembershipsResource(options);
    this.orderAddressValidations = new OrderAddressValidationsResource(options);
    this.users = new UsersResource(options);
    this.userOneTimeTokens = new UserOneTimeTokensResource(options);
    this.orderDetails = new OrderDetailsResource(options);
    this.orderSettings = new OrderSettingsResource(options);
    this.checkoutConfigurations = new LegacyCheckoutConfigurationsResource(options);
    this.debugTransactions = new InternalDebugTransactionsResource(options);
    this.labelRequestResults = new LabelRequestResultsResource(options);
  }
}

export function createClient(options: $HttpClientOptions): ApiInternalClientV2 {
  return new ApiInternalClientV2(options);
}
